import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form, Button } from "antd";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { List } from "immutable";
import { INPUT_TYPES } from "constants";
import { TABLE_DATA_TYPES } from "constants/table-data-types";
import "styles/form.css";

const FormItem = Form.Item;

class TableFiltersForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = e => {
        e.preventDefault();
        const { form } = this.props;
        form.validateFields((err, values) => {
            if (!err) {
                this.props.submit(values);
            }
        });
    };

    getFields(col) {
        if (col.dataType === TABLE_DATA_TYPES.STRING || col.dataType === 3) {
            return {
                type: INPUT_TYPES.TEXT,
                placeholder: col.title,
                label: col.title,
                className: "form-field fb-25"
            };
        }
        if (col.dataType === TABLE_DATA_TYPES.BOOLEAN) {
            return {
                type: INPUT_TYPES.SELECT,
                options: new List([
                    {label: "Yes", value: "True"},
                    {label: "No", value: "False"},
                ]),
                placeholder: col.title,
                label: col.title,
                className: "form-field fb-25"
            };
        }
        if (col.dataType === TABLE_DATA_TYPES.SELECT) {
            return {
                type: INPUT_TYPES.SELECT,
                options: new List(col.options),
                placeholder: col.title,
                label: col.title,
                mode: col.mode,
                className: "form-field fb-25"
            };
        }
        if (col.dataType === TABLE_DATA_TYPES.ENUM) {
            return {
                type: INPUT_TYPES.SELECT,
                options: col.enums && col.enums.map((v, k) => ({
                    label: k,
                    value: String(v)
                })).toList(),
                mode: "multiple",
                placeholder: col.title,
                label: col.title,
                className: "form-field fb-25"
            };
        }
        if (col.dataType === TABLE_DATA_TYPES.DATE || col.dataType === 4) {
            return {
                type: INPUT_TYPES.DATE_RANGE,
                placeholder: ["Min", "Max"],
                label: col.title,
                className: "form-field fb-25"
            };
        }
        if (col.dataType === TABLE_DATA_TYPES.CURRENCY || col.dataType === 6 || col.dataType === 2) {
            return {
                type: INPUT_TYPES.NUMBER_RANGE,
                placeholder: ["Min", "Max"],
                label: col.title,
                className: "form-field fb-25"
            };
        }
        if (col.dataType === TABLE_DATA_TYPES.NUMBER || col.dataType === 1) {
            return {
                type: INPUT_TYPES.NUMBER_RANGE,
                placeholder: ["Min", "Max"],
                label: col.title,
                className: "form-field fb-25"
            };
        }
    }

    render() {
        const {
            form: { resetFields },
            columns
        } = this.props;
        return (
            <Form
                onSubmit={this.handleFormSubmit}
                layout={"vertical"}
                className={cx("form", "br-3")}
                hideRequiredMark={false}>
                <div className={"form-row"}>
                    {columns
                        .filter(_ => !["action", "actions", "docs"].includes(_.key))
                        .filter(_ => !_.notFilterApplicable)
                        .map(_ => {
                            let field = this.getFields(_);
                            return this.fieldGenerator(
                                _.searchKey || _.key,
                                {
                                    ...field
                                },
                                this.getErrorOnField(_.searchKey || _.key)
                            )();
                        })
                        .toList()}
                </div>
                <div className={"form-row justify-content-flex-end"}>
                    <FormItem className={"form-btn m-0"}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            icon={"search"}
                            className={"mr-5"}>
                            Search
                        </Button>
                    </FormItem>
                    <FormItem className={"form-btn m-0"}>
                        <Button type="default" onClick={() => resetFields()}>
                            Clear
                        </Button>
                    </FormItem>
                </div>
            </Form>
        );
    }
}

TableFiltersForm.propTypes = {
    columns: PropTypes.object,
    form: PropTypes.object,
    submit: PropTypes.func
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        if (values && values.size) {
            return values
                .map(_ =>
                    Form.createFormField({
                        value: _
                    })
                )
                .toJS();
        }
    }
})(TableFiltersForm);
